export default [
  {
    title: 'Adjust E-stamp',
    customIcon: 'AdjustEstampSVG',
    children: [
      {
        title: "Adjust E-stamp Point",
        route: "custom-adjust-e-stamp-point",
        path: "/custom-adjust-e-stamp-point/list",
      },
    ]
  },
];